module.exports = __webpack_public_path__ + "static/media/female.06c7437f.svg";